// Scroll reveal for lander sections: [data-reveal] elements fade-rise once as
// they enter the viewport (data-reveal-stagger animates children instead, see
// index.css). .reveal-init is only ever added here, so without JS nothing is
// hidden; above-fold elements are skipped so first paint never flashes.
(function (window, document) {
    function init() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!('IntersectionObserver' in window)) return;
        var els = document.querySelectorAll('[data-reveal]');
        if (!els.length) return;
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
                if (!e.isIntersecting) return;
                io.unobserve(e.target);
                e.target.classList.add('reveal-in');
                // let go after the entrance so hover transforms (card-lift) work again
                setTimeout(function () {
                    e.target.classList.remove('reveal-init', 'reveal-in');
                }, 1100);
            });
        }, { rootMargin: '0px 0px -10% 0px' });
        var fold = (window.innerHeight || document.documentElement.clientHeight) * 0.9;
        els.forEach(function (el) {
            if (el.getBoundingClientRect().top < fold) return;
            el.classList.add('reveal-init');
            io.observe(el);
        });
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})(window, document);
